export default () => ({

    swiper: null,

    /**
     * Для инициализации слайдера
     * используется аттрибут `x-intersect.once="initSlider"`
     */
    initSlider() {
        // noinspection JSUnresolvedReference
        let slidesPerView = this.$root.dataset.slidesPerView ?? 1;

        // noinspection JSUnresolvedReference
        this.swiper = new Swiper(this.$root.querySelector('.swiper'), {
            slidesPerView,
            loop: false,
            spaceBetween: 16,
            autoHeight: true,
            observer: true,
            observeParents: true,
            watchOverflow: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            }
        });
    }

});
